<template>
    
    <tr :class="'bundled_item_' + prod.ID + ' menu_' + prod.tipo" class="  bundled_product_summary product has_qty_input menu_menu" :data-type="prod.tipo">
        <td class="bundled_item_col bundled_item_images_col">
            <div class="bundled_product_images images" style="opacity: 1;" bis_skin_checked="1">
                <figure v-if="prod.image" class="bundled_product_image woocommerce-product-gallery__image">
                    <img :src="(prod.image ? prod.image : '')" class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail wp-post-image" alt="" decoding="async" :title="prod.post_title" >
                </figure>
            </div>
        </td>
        <td class="bundled_item_col bundled_item_details_col">
            <div class="details" bis_skin_checked="1">
                <h5 class="bundled_product_title product_title">
                    <span class="bundled_product_title_inner">
                        <span class="item_title">{{ prod.post_title }}</span>
                        <span class="item_qty"></span>
                        <span class="item_suffix"></span>
                    </span>
                </h5>
                <div class="bundled_product_details" bis_skin_checked="1">
                    <div class="bundled_product_excerpt product_excerpt" bis_skin_checked="1">
                        <p v-html="prod.post_excerpt"></p>
                    </div>
                </div>
                <div v-if="prod.allergeni" class="icons-attributes flex-fill d-none d-md-block" bis_skin_checked="1">
                    <small><i>Contiene:</i></small>
                    <div v-for="(attributo, a) in prod.allergeni" :key="'allerg_'+a" class="d-inline-flex flex-column align-items-center text-center mw-90 minw-90 gy-4 mb-3 me-1">
                        <img class="mw-40 w-100" :src="attributo.icon.url" :alt="attributo.name">
                        <span class="fs-xxs font-alt ls-wide text-uppercase mt-2 text-break">{{attributo.name}}</span> 
                    </div>
             
        </div>
            </div>
        </td>
        <td class="bundled_item_col bundled_item_qty_col">
            <div class="quantity" bis_skin_checked="1">
                <input type="button" value="-" class="minus" @click="rem(prod)">	
                <span class="qty text-center border-0 fw-medium d-inline-block">{{ quantity }}</span>
                <input type="button" value="+" class="plus" @click="add(prod)">
            </div>
        </td>
    </tr>
</template>

<script>
export default {
    name: "ProductSheet",
    data(){
        return {
            quantity: 0
        }
    },
    props: {
        prod: Object,
        max: Number
    },
    computed:{
        selected() {
            return this.$store.state.abbonamento.products;
        }
    },
    beforeMount(){
        let sel = this.selected.filter(product => product.id == this.prod.ID);
        // this.log('quantity: ',this.prod.ID, sel[0]);
        if (sel.length > 0)
            this.quantity = parseInt(sel[0].quantity);
    },
    methods: {
        add(prod){
            if (this.quantity < this.max) {
                this.quantity +=1;
                this.$emit("update", {
                    id: prod.ID,
                    quantity: this.quantity,
                    tipo: prod.tipo,
                    name: prod.post_title,
                    image: prod.image,
                    sku: prod.sku

                });
            }
        },
        rem(prod) {
            if(this.quantity>0){
                this.quantity -= 1;
                this.$emit("update", {
                    id: prod.ID,
                    quantity: this.quantity
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.product{
    img{
        width: 100px;
        height: auto;
    }
    td{
        padding: 1.5em;
        padding-left: 0;
        vertical-align: middle;
    }
    .quantity{
        input.minus, input.plus{
            box-shadow: none;
            border: 1px solid #fff;
            border-radius: 50%;
            background-color: transparent;
            color: #fff;
            width: 35px;
            height: 35px;
            text-shadow: none;
            padding: 0;
            margin: 0;
        }
        .qty{
            background-color: transparent;
            padding: 0px 5px 0 !important;
            -moz-appearance: textfield;
            appearance: textfield;
            width: 2em;
        }
    }
    .bundled_item_col.bundled_item_qty_col{
        width: 126px;
    }
}
</style>